import React from 'react';

// Componente agora recebe props desestruturadas
function RelatorioPedido({ pedido, cliente, tenant, itens, financeiro }) {

    // Funções auxiliares ajustadas para receber string ou Date
    const formatarData = (dataIsoString) => {
        if (!dataIsoString) return 'N/A';
        try {
            const data = new Date(dataIsoString);
             // Adiciona algumas horas para compensar possíveis problemas de fuso no parse
            data.setUTCHours(12, 0, 0, 0);
            return data.toLocaleDateString('pt-BR');
        } catch (error) {
            return 'Data Inválida';
        }
    };

    const formatarMoeda = (valor) => {
        return (Number(valor) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    // Cálculos dos totais (usando os nomes corretos dos campos vindos da API)
    const totalItens = itens.reduce((acc, item) => acc + (Number(item.valor_subtotal) || 0), 0);
    const totalPedido = totalItens + (Number(pedido.acrescimos) || 0) + (Number(pedido.frete) || 0);
    const totalVol = itens.reduce((acc, item) => acc + (Number(item.quantidade_volumes) || 0), 0);
    const totalQtPares = itens.reduce((acc, item) => acc + (Number(item.quantidade_total) || 0), 0);

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', color: '#333', margin: 'auto', padding: '20px', maxWidth: '800px', border: '1px solid #ccc' }}>
            
            <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #333', paddingBottom: '10px' }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '24px' }}>{tenant.nome || 'Nome da Empresa'}</h1>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <h2 style={{ margin: 0, fontSize: '20px' }}>Pedido Nº: {pedido.numero}</h2>
                    <p style={{ margin: 0 }}>Data: {formatarData(pedido.dataCadastro)}</p>
                </div>
            </header>

            <section style={{ marginTop: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                <h3 style={{ margin: 0, fontSize: '16px',fontWeight: 'bold', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>Dados do Cliente</h3>
                <div style={{ marginTop: '10px' }}>
                    <p style={{ margin: '2px 0' }}><strong>Nome:</strong> {cliente.nome || 'Não informado'}</p>
                    <p style={{ margin: '2px 0' }}><strong>Endereço:</strong> {`${cliente.rua || ''}, ${cliente.numero || ''} - ${cliente.bairro || ''}, ${cliente.cidade || ''} - ${cliente.uf || ''}`}</p>
                    <p style={{ margin: '2px 0' }}><strong>Telefone:</strong> {cliente.telefone || 'Não informado'}</p>
                </div>
            </section>

            <section style={{ marginTop: '20px' }}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>Itens do Pedido</h3>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd' }}>Produto</th>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd' }}>Cor</th>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd' }}>Grade</th>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Qt. Vol.</th>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Qt. Pares</th>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Vlr. Unit.</th>
                            <th style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itens.map((item, index) => ( // Agora usa 'item.produto_descricao' e 'item.grade_descricao'
                            <tr key={item.id || index}>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd' }}>{item.produto_descricao}</td>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd' }}>{item.cor || '--'}</td>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd' }}>{item.grade_descricao || '--'}</td>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'center' }}>{item.quantidade_volumes}</td>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'center' }}>{item.quantidade_total}</td>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'right' }}>{formatarMoeda(item.preco_venda)}</td>
                                <td style={{ padding: '8px',fontSize: '12px', border: '1px solid #ddd', textAlign: 'right' }}>{formatarMoeda(item.valor_subtotal)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

            <footer style={{ marginTop: '20px', borderTop: '2px solid #333', paddingTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ flex: 1 }}>
                    <h3 style={{ margin: 0, fontSize: '16px' }}>Condição de Pagamento</h3>
                    {financeiro.length > 0 ? (
                        financeiro.map((fin, index) => ( // Usa 'data_vencimento'
                            <p key={fin.id || index} style={{ margin: '2px 0' }}>
                                {fin.forma_pagamento} - {formatarMoeda(fin.valor_total)} (Venc: {formatarData(fin.data_vencimento)})
                            </p>
                        ))
                    ) : (
                        <p style={{ margin: '2px 0' }}>Não especificado</p>
                    )}
                </div>
                <div style={{ flex: 1, textAlign: 'right' }}>
                     <p style={{ margin: '5px 0', fontSize: '14px' }}><strong>Total de Volumes:</strong> {totalVol}</p>
                     <p style={{ margin: '5px 0', fontSize: '14px' }}><strong>Total de Pares:</strong> {totalQtPares}</p>
                     <hr style={{ border: 'none', borderTop: '1px solid #eee' }} />
                     <p style={{ margin: '5px 0' }}><strong>Subtotal dos Itens:</strong> {formatarMoeda(totalItens)}</p>
                     <p style={{ margin: '5px 0' }}><strong>Acréscimos:</strong> {formatarMoeda(pedido.acrescimos)}</p>
                     <p style={{ margin: '5px 0' }}><strong>Frete:</strong> {formatarMoeda(pedido.frete)}</p>
                     <h3 style={{ margin: '10px 0 0 0', fontSize: '18px' }}><strong>Total do Pedido:</strong> {formatarMoeda(totalPedido)}</h3>
                </div>
            </footer>
        </div>
    );
}

export default RelatorioPedido;